// ContactSection.jsx
import React from 'react';
import { Mail, MapPin, Github, Linkedin } from 'lucide-react';

const ContactSection = () => {
  return (
    <section className="mt-10 md:mt-20 relative">
      <div className="container mx-auto px-4">
        {/* Social Links Section */}
        <div className="mb-8 md:mb-16">
          <h2 className="text-2xl md:text-3xl font-tech text-center mb-6 md:mb-8">
            <span className="text-fuchsia-500">&lt;</span>
            CONNECT_WITH_ME
            <span className="text-fuchsia-500">/&gt;</span>
          </h2>
          
          <div className="flex justify-center gap-4 md:gap-6 flex-wrap">
            <a 
              href="https://www.linkedin.com/in/nagaraj08-k/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 px-4 md:px-6 py-2 md:py-3 bg-black/50 
                       border-2 border-fuchsia-500 rounded-lg text-sm md:text-base
                       hover:bg-fuchsia-500/10 hover:scale-110 transition-all duration-300"
            >
              <Linkedin className="w-4 h-4 md:w-5 md:h-5 text-cyan-400" />
              <span className="text-fuchsia-500 font-tech">LinkedIn</span>
            </a>
            <a 
              href="https://github.com/NAGARAJ08"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 px-4 md:px-6 py-2 md:py-3 bg-black/50 
                       border-2 border-cyan-400 rounded-lg text-sm md:text-base
                       hover:bg-cyan-500/10 hover:scale-110 transition-all duration-300"
            >
              <Github className="w-4 h-4 md:w-5 md:h-5 text-fuchsia-500" />
              <span className="text-cyan-400 font-tech">GitHub</span>
            </a>
          </div>
        </div>

        {/* Contact Info Section */}
        <div id="contact" className="max-w-2xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-tech text-center mb-6 md:mb-8">
            <span className="text-cyan-400">&lt;</span>
            CONTACT_INFO
            <span className="text-cyan-400">/&gt;</span>
          </h2>
          
          <div className="space-y-4 md:space-y-6">
            <a 
              href="mailto:kbnagaraj18@gmail.com"
              className="flex items-center gap-3 md:gap-4 p-3 md:p-4 bg-black/30 
                       border-l-4 border-fuchsia-500 hover:bg-fuchsia-500/10 
                       hover:translate-x-2 transition-all duration-300 block"
            >
              <Mail className="w-5 h-5 md:w-6 md:h-6 text-fuchsia-500" />
              <div>
                <p className="text-cyan-400 font-tech text-xs md:text-sm">EMAIL</p>
                <p className="text-green-500 hover:text-fuchsia-500 text-sm md:text-base">
                  kbnagaraj18@gmail.com
                </p>
              </div>
            </a>
{/* 
            <div className="flex items-center gap-3 md:gap-4 p-3 md:p-4 bg-black/30 
                         border-l-4 border-cyan-400 hover:bg-cyan-500/10 
                         hover:translate-x-2 transition-all duration-300">
              <Phone className="w-5 h-5 md:w-6 md:h-6 text-cyan-400" />
              <div>
                <p className="text-fuchsia-500 font-tech text-xs md:text-sm">PHONE</p>
                <p className="text-green-500 text-sm md:text-base">+91 9916015591</p>
              </div>
            </div> */}

            <div className="flex items-center gap-3 md:gap-4 p-3 md:p-4 bg-black/30 
                         border-l-4 border-fuchsia-500 hover:bg-fuchsia-500/10 
                         hover:translate-x-2 transition-all duration-300">
              <MapPin className="w-5 h-5 md:w-6 md:h-6 text-fuchsia-500" />
              <div>
                <p className="text-cyan-400 font-tech text-xs md:text-sm">LOCATION</p>
                <p className="text-green-500 text-sm md:text-base">Hyderabad, India</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default ContactSection;